import { mapState } from "vuex";
import featureFlagsMixin from "@/mixins/featureFlags";
import {
  DEFAULT_CARD_BRANDING,
  DEFAULT_CARD_NAME,
  assignedIssuerStatement,
  assignedPhysicalCardImageUrl,
  cardDisplayName,
  clientCardImageUrl,
} from "@/utils/cardProduct";

// The one place card copy and images branch on feature-marqeta-card-products,
// so removing the flag (192399) touches this file instead of every card screen.
// On reads the card product data GET /cards returns; off keeps the Whistle card.
export default {
  mixins: [featureFlagsMixin],
  computed: {
    ...mapState(["marqeta", "userProfile"]),
  },
  methods: {
    // Null until GET /cards loads when the flag is on. Without a type, a held card of either type wins.
    cardProductName(type) {
      return this.isMarqetaCardProductsEnabled()
        ? cardDisplayName(this.marqeta, type)
        : DEFAULT_CARD_NAME;
    },
    // Null until GET /cards loads when the flag is on, so the legal sentence never shows the wrong issuer.
    cardProductIssuerStatement(type) {
      return this.isMarqetaCardProductsEnabled()
        ? assignedIssuerStatement(this.marqeta, type)
        : DEFAULT_CARD_BRANDING.issuerStatement;
    },
    // Null to show the bundled default card image.
    cardProductPhysicalImage() {
      return this.isMarqetaCardProductsEnabled()
        ? assignedPhysicalCardImageUrl(this.marqeta)
        : clientCardImageUrl(this.userProfile);
    },
  },
};
